import $ from 'jquery';

export default function int_accordion() {
	const accordionBtns = document.querySelectorAll(".modules-accordion_list-item");
	/*
	accordionBtns.forEach((accordion) => {
		accordion.addEventListener("click", function () {
			this.classList.toggle("is-open");

			let content = this.querySelector('.content');

			if (content.style.height) {
				//content.style.height = null;
			} else {
				//content.style.height = content.scrollHeight + "px";
			}
		});
	});
	*/
	$(".toggle-acc").click(function(){
		$(this).closest(".modules-accordion_list-item").toggleClass("is-open");
	});
	
	$(document).ready(function(){
		if ($(".modules-accordion").length){
			if(window.location.hash) {
				var inhash =  $(window.location.hash);
				
				if (inhash.hasClass("modules-accordion_list-item")){
					
					inhash.find(".toggle-acc").trigger("click");
					setTimeout (function(){
						inhash.get(0).scrollIntoView({behavior: 'smooth'});
					
					}, 2000);
				}
			}
		}
	});
}